export default __webpack_public_path__ + "static/media/planets.1b0d1fd1.jpeg";